import React from 'react';
import {Alert, Button, CircularProgress, Divider, Stack, TextField, Typography} from '@mui/material';
import {AutoAwesome} from '@mui/icons-material';
import ExpertCard from './ExpertCard';
import {useSession} from "../../../../../../firebase/UserProvider";
import useExpertStore from "../../../../../../stores/useExpertStore";

const AIExpertSuggestions = () => {
    const {user} = useSession();

    // Zustand store
    const {
        instructions,
        experts,
        loading,
        error,
        setInstructions,
        generateExperts,
    } = useExpertStore();

    const hasInstructions = instructions && instructions.trim().length > 0;

    return (
        <Stack p={2} spacing={2}>
            <Typography variant="body2" color="text.secondary">
                Let AI analyze your report and suggest relevant experts based on the content and topics covered.
            </Typography>

            <TextField
                label="Describe CME (optional)"
                placeholder="E.g., Focus on experts with Middle East experience..."
                multiline
                minRows={2}
                size="small"
                value={instructions}
                onChange={(e) => setInstructions(e.target.value)}
                fullWidth
            />

            <Button
                variant="outlined"
                startIcon={<AutoAwesome/>}
                onClick={() => generateExperts()}
                disabled={loading}
            >
                {loading
                    ? 'Analyzing...'
                    : hasInstructions
                        ? 'Find based on description'
                        : 'Re-analyze Report'
                }
            </Button>

            <Divider/>

            {loading ? (
                <Stack alignItems="center" py={4} spacing={2}>
                    <CircularProgress size={32}/>
                    <Typography variant="body2" color="text.secondary">
                        {hasInstructions
                            ? 'Finding experts matching your description...'
                            : 'Analyzing your report to find matching experts...'}
                    </Typography>
                </Stack>
            ) : error ? (
                <Alert severity="error">
                    {error}
                </Alert>
            ) : experts.length > 0 ? (
                <Stack spacing={1}>
                    <Typography variant="subtitle2" fontWeight={600}>
                        Suggested Experts
                    </Typography>
                    {[...experts]
                        .sort((a, b) => (b.matchScore ?? 0) - (a.matchScore ?? 0))
                        .map((expert, index) => (
                            (!expert.uid || user.uid !== expert.uid) &&
                            <ExpertCard key={expert.uid || expert.handle || expert.email || index} expert={expert}/>
                        ))
                    }
                </Stack>
            ) : (
                <Alert severity="info">
                    No experts found. Try adjusting your instructions.
                </Alert>
            )}
        </Stack>
    );
};

export default AIExpertSuggestions;
